import EcoImg from 'eco-design/base/eco-img';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function G1() {
    const { useLang } = useGlobal();
    const { t } = useLang('vanliferoadtrips');

    return (
        <div id="vanlife-roadtrips-G" className={`vanlife-roadtrips-G1 ${css['vanlife-roadtrips-G1']}`}>
            <EcoImg
                pc="https://websiteoss.ecoflow.com/figma-uploads/1786433186323-xuo8w6-compressed-004.webp"
                h5="https://websiteoss.ecoflow.com/figma-uploads/1786433223087-nogihy-compressed-004.webp"
                alt={t('secG_title')}
                aria-label={t('secG_title')}
            />
            <div className="info">
                <p className="title">{t('secG_title')}</p>
                <p className="desc">{t('secG_desc')}</p>
            </div>
        </div>
    );
}
